
import { Component, Prop, Vue } from "vue-property-decorator";
import settings from "@/settings";
import { UserModule } from "@/store/modules/user";

@Component({
    name: "SidebarLogo",
})
export default class extends Vue {
    @Prop({ required: true }) private collapse!: boolean;

    private title = settings.title;

    get info() {
        return UserModule.mainInfo;
    }
}
